// Styles partagés des vues du suivi patient et du suivi livraison.

export const TH = {
    padding: "9px 10px",
    textAlign: "left",
    fontSize: "10px",
    fontWeight: 700,
    color: "#94a3b8",
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    background: "#f8fafc",
    borderBottom: "2px solid #e2e8f0",
    whiteSpace: "nowrap",
    position: "sticky",
    top: 0,
    zIndex: 2,
};

export const TD = {
    padding: "10px",
    verticalAlign: "middle",
    fontSize: "12.5px",
    color: "#334155",
    borderBottom: "1px solid #f1f5f9",
    whiteSpace: "nowrap",
};

export const controlStyle = {
    padding: "5px 10px",
    border: "none",
    fontSize: "12px",
    color: "#334155",
    outline: "none",
    background: "white",
};

export const buttonSecondary = {
    padding: "6px 14px",
    borderRadius: "7px",
    border: "1px solid #e2e8f0",
    background: "white",
    cursor: "pointer",
    fontSize: "12.5px",
    color: "#475569",
    fontWeight: 500,
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
};

export const buttonPrimary = {
    padding: "6px 10px",
    borderRadius: "7px",
    border: "1px solid #bfdbfe",
    background: "#eff6ff",
    color: "#2563eb",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: 700,
};

export const photoButtonStyle = { ...buttonPrimary, background: "#f5f3ff", color: "#6d28d9", borderColor: "#ddd6fe" };

export const deliveryInfoStyle = {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    gap: "14px",
    padding: "8px 10px",
    borderRadius: "7px",
    border: "1px solid #e2e8f0",
    background: "#f8fafc",
    color: "#475569",
    fontSize: "12px",
};

export const deliveryDateGroupStyle = {
    marginBottom: "16px",
};

export const deliveryDateHeaderStyle = {
    position: "sticky",
    top: 0,
    zIndex: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    margin: "0 0 8px",
    padding: "9px 10px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    background: "#f8fafc",
    color: "#0f172a",
    fontSize: "13px",
    fontWeight: 800,
    textTransform: "capitalize",
    boxShadow: "0 1px 0 rgba(15, 23, 42, 0.04)",
};

export function livraisonListItemStyle(active) {
    return {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
        marginBottom: "8px",
        padding: "11px 12px",
        borderRadius: "8px",
        border: `1px solid ${active ? "#bfdbfe" : "#e2e8f0"}`,
        background: active ? "#eff6ff" : "white",
        cursor: "pointer",
        textAlign: "left",
        boxShadow: active ? "0 1px 0 rgba(37, 99, 235, 0.08)" : "none",
    };
}

export const retraiterButtonStyle = {
    ...buttonPrimary,
    width: "136px",
    minHeight: "32px",
    justifyContent: "center",
    whiteSpace: "normal",
    lineHeight: 1.15,
    textAlign: "center",
};

export const commandeBlockStyle = {
    marginBottom: "12px",
    border: "1px solid #e2e8f0",
    borderRadius: "10px",
    background: "white",
    overflow: "hidden",
};

export const commandeSummaryStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    padding: "12px 14px",
    cursor: "pointer",
    background: "#f8fafc",
    borderBottom: "1px solid #e2e8f0",
};

export const destinationBlockStyle = {
    marginTop: "12px",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    background: "#f8fafc",
};

export const destinationBlockHeaderStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
};

export const listMoreStyle = {
    padding: "12px",
    textAlign: "center",
    color: "#94a3b8",
    fontSize: "12px",
};

export const tabsBar = {
    display: "inline-flex",
    alignItems: "flex-end",
    gap: "2px",
    borderBottom: "1px solid #cbd5e1",
    flexWrap: "wrap",
    paddingTop: "2px",
};

export function tabButton(active) {
    return {
        border: "1px solid #cbd5e1",
        borderBottomColor: active ? "white" : "#cbd5e1",
        borderRadius: "8px 8px 0 0",
        padding: active ? "7px 15px 8px" : "6px 14px 7px",
        marginBottom: active ? "-1px" : "0",
        background: active ? "white" : "#f8fafc",
        color: active ? "#0f172a" : "#64748b",
        boxShadow: active ? "0 -1px 0 white, 0 1px 2px rgba(15,23,42,0.06)" : "none",
        cursor: "pointer",
        fontSize: "12.5px",
        fontWeight: 700,
        position: "relative",
        zIndex: active ? 2 : 1,
    };
}

export function patientButton(active) {
    return {
        width: "100%",
        border: active ? "1px solid #c7d2fe" : "1px solid transparent",
        background: active ? "#eef2ff" : "transparent",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "8px",
        borderRadius: "8px",
        textAlign: "left",
        marginBottom: "4px",
    };
}
